import { Controller } from '@hotwired/stimulus'
import TomSelect from 'tom-select/dist/js/tom-select.complete.min.js'

export default class extends Controller {
  static targets = ['select']

  connect() {
    // Initialize tom-select on all select targets
    this.selectTargets.forEach(select => {
      this.initializeTomSelect(select)
    })
  }

  initializeTomSelect(element) {
    if (element.tomselect) return // Already initialized

    const placeholder = element.dataset.placeholder || 'Select an option'

    // Ensure we have a valid select element with options
    if (!element || element.tagName !== 'SELECT') {
      console.warn('TomSelect: Element is not a valid select element', element)
      return
    }

    new TomSelect(element, {
      placeholder: placeholder.toString(),
      allowEmptyOption: true,
      searchInDropdown: true,
      closeAfterSelect: true,
      items: [],
      controlClass: 'pt-4 ps-3 ts-control',
    })
  }

  disconnect() {
    // Clean up tom-select instances
    this.selectTargets.forEach(select => {
      if (select.tomselect) {
        select.tomselect.destroy()
      }
    })
  }
}
